<template>
    <div class="footer-wrap">
        <div class="records">2011-2019 Copyrights reserved 京ICP备05006316号    版权所有: 中国互联网协会</div>
    </div>
</template>
<script>
export default {
    name: 'Footers'

}
</script>



// WEBPACK FOOTER //
// src/template/Footer.vue